const MOBILE_MQ = "(max-width: 1024px)";
const PX_PER_SECOND = 30;
const PAUSE_AFTER_INTERACTION = 3000;

export function initProductionCarousel(container) {
  const list = (container || document).querySelector(
    ".c-production__media-list"
  );
  if (!list) return null;

  const items = Array.from(
    list.querySelectorAll(".c-production__media-item")
  );
  if (items.length < 2) return null;

  const mql = window.matchMedia(MOBILE_MQ);
  let raf = null;
  let paused = false;
  let pauseTimer = null;
  let destroyed = false;
  let running = false;
  let lastTime = 0;
  let subPixel = 0;

  function maxScroll() {
    return list.scrollWidth - list.clientWidth;
  }

  function step(timestamp) {
    if (destroyed) return;

    if (!paused && mql.matches) {
      if (lastTime) {
        const delta = timestamp - lastTime;
        subPixel += (PX_PER_SECOND * delta) / 1000;
        const px = Math.floor(subPixel);
        if (px >= 1) {
          subPixel -= px;
          const max = maxScroll();
          if (max > 0) {
            const next = list.scrollLeft + px;
            if (next >= max) {
              list.scrollTo(0, 0);
              subPixel = 0;
            } else {
              list.scrollTo(next, 0);
            }
          }
        }
      }
      lastTime = timestamp;
    } else {
      lastTime = 0;
      subPixel = 0;
    }

    raf = requestAnimationFrame(step);
  }

  function pauseTemporarily() {
    paused = true;
    clearTimeout(pauseTimer);
    pauseTimer = setTimeout(() => {
      paused = false;
    }, PAUSE_AFTER_INTERACTION);
  }

  function onTouchStart() {
    paused = true;
    clearTimeout(pauseTimer);
  }

  function onTouchEnd() {
    pauseTimer = setTimeout(() => {
      paused = false;
    }, PAUSE_AFTER_INTERACTION);
  }

  function onWheel() {
    pauseTemporarily();
  }

  function start() {
    if (running || !mql.matches) return;
    running = true;

    items.forEach((item) => {
      const clone = item.cloneNode(true);
      clone.setAttribute("aria-hidden", "true");
      clone.classList.add("is-clone");
      list.appendChild(clone);
    });

    list.addEventListener("touchstart", onTouchStart, { passive: true });
    list.addEventListener("touchend", onTouchEnd, { passive: true });
    list.addEventListener("wheel", onWheel, { passive: true });
    lastTime = 0;
    subPixel = 0;
    raf = requestAnimationFrame(step);
  }

  function stop() {
    if (!running) return;
    running = false;
    cancelAnimationFrame(raf);
    raf = null;
    lastTime = 0;
    subPixel = 0;
    clearTimeout(pauseTimer);
    paused = false;

    list.querySelectorAll(".is-clone").forEach((c) => c.remove());
    list.removeEventListener("touchstart", onTouchStart);
    list.removeEventListener("touchend", onTouchEnd);
    list.removeEventListener("wheel", onWheel);
  }

  function onMediaChange() {
    if (destroyed) return;
    if (mql.matches) {
      start();
    } else {
      stop();
    }
  }

  function onVisibility() {
    if (document.hidden) {
      paused = true;
    } else {
      paused = false;
    }
  }

  mql.addEventListener("change", onMediaChange);
  document.addEventListener("visibilitychange", onVisibility);

  setTimeout(() => {
    if (!destroyed) onMediaChange();
  }, 600);

  return function destroy() {
    destroyed = true;
    stop();
    mql.removeEventListener("change", onMediaChange);
    document.removeEventListener("visibilitychange", onVisibility);
  };
}
